import { cutApiUrl } from "@/api/helper";
import { getApiUrl } from "@/data/constants";
import { nullToUndefined } from "@/helper/undefinedToNull";
import { AllMyStorageApiClient } from "@/models/generated-api-schema/AllMyStorageApiClient"
import type { OpenAPIConfig } from "@/models/generated-api-schema/core/OpenAPI";

export function createClient(options?: Partial<OpenAPIConfig>): AllMyStorageApiClient {
  const token: string | undefined = nullToUndefined(localStorage.getItem("accessToken"));
  return new AllMyStorageApiClient({
    BASE: cutApiUrl(getApiUrl()),
    TOKEN: token,
    ...options,
  });
}
